export const PAGE_SIZE = 10
export const currentDomain = window.location.origin
